import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Image } from '@ravago/shared/radiance/components/image/components/Image/Image';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   requestQuoteError: boolean;
}

export const RfqFlyoutStepFinalMessage = ({ requestQuoteError }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         {requestQuoteError ? (
            <Box height="60vh" width="auto" direction="column" justify="center" items="center" gap="xl" spacing={{ left: '3xl', right: '3xl' }}>
               <Image
                  src="/images/rfq-error.png"
                  alt={translate('page-consumer.request-for-quotation.error')}
                  title={translate('page-consumer.request-for-quotation.error')}
                  objectFit="contain"
               />
               <Typography align="center" component="h4" variant="heading-4" color="primary">
                  {translate('page-consumer.request-for-quotation.error')}
               </Typography>
               <Typography align="center" component="b" variant="body" color="strong">
                  {translate('page-consumer.request-for-quotation.error-message')}
               </Typography>
            </Box>
         ) : (
            <Box height="60vh" width="auto" direction="column" justify="center" items="center" gap="xl" spacing={{ left: '3xl', right: '3xl' }}>
               <Image
                  src="/images/rfq-thank-you.png"
                  alt={translate('page-consumer.request-for-quotation.thank-you')}
                  title={translate('page-consumer.request-for-quotation.thank-you')}
                  objectFit="contain"
               />
               <Typography align="center" component="h4" variant="heading-4" color="primary">
                  {translate('page-consumer.request-for-quotation.thank-you')}
               </Typography>
               <Typography align="center" component="b" variant="body" color="strong">
                  {translate('page-consumer.request-for-quotation.thank-you-message')}
               </Typography>
            </Box>
         )}
      </Box>
   );
};
